export class AccumulativeReport {
    constructor(
      public answerAVG?: number,
      public categoryTitle?: string
    ) { }

    clone() {
      return new AccumulativeReport(
        this.answerAVG,
        this.categoryTitle
      );
    }
  }

